export const DEFAULT_API_VERSION = 'unstable';
